import React from "react";
import classNames from "classnames";
import Styles from "./RouteState.module.scss";

//icons
import PlusDark from "@vahak/core/dist/icons/PlusDark.svg";
import TickBlue from "@vahak/core/dist/icons/tick_blue.svg";
import Typography from "@vahak/core-ui/dist/components/Typography";
import COLORS from "@vahak/core-ui/dist/constants/colors";

interface RouteStateProps {
    routeValue?: string;
    isSelect?: boolean;
    isSectionRoute?: boolean;
    routeClass?: string;
    onClickSelect: (id: number) => void;
    index?: number;
}

const RouteState = ({ routeValue, isSelect, isSectionRoute, routeClass, onClickSelect, index }: RouteStateProps) => {
    return (
        <div
            className={classNames(Styles.route, routeClass, isSelect && Styles.selected)}
            onClick={() => index && onClickSelect(index)}
            key={index}
        >
            {!isSectionRoute && <>{isSelect ? <TickBlue /> : <PlusDark />}</>}
            <Typography size="sm" color={COLORS.GREY_700} weight="medium">
                {routeValue}
            </Typography>
        </div>
    );
};

export default RouteState;
